import React from 'react'

import PropTypes from 'prop-types'
import {Box, Button, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {ThemeProvider, LogoHorizontal} from '../../components'

// Where an OAuth client, such as the partner portal, sends the browser from its own sign out. A signed in
// person confirms with a button, which POSTs with a CSRF token, so another site cannot log them out with a link.
const LogoutScreen = ({signedIn, logoutPath, authenticityToken}) => {
  const {t} = useTranslation('auth')

  return (
    <ThemeProvider>
      <Box minH="100vh">
        <Box
          maxWidth="500px"
          position="absolute"
          top="40%"
          left="0"
          right="0"
          transform="translateY(-40%)"
          px="sm"
          margin="0 auto"
        >
          <LogoHorizontal w="323px" h="38px" mb="md" />
          {signedIn ? (
            <form method="POST" acceptCharset="UTF-8" action={logoutPath}>
              <input
                type="hidden"
                name="authenticity_token"
                value={authenticityToken}
              />
              <Text as="h1" textStyle="headline4" mb="sm">
                {t('auth:logOut.title')}
              </Text>
              <Text textStyle="body-copy" mb="md">
                {t('auth:logOut.body')}
              </Text>
              <Button variant="secondary" type="submit" w="100%">
                {t('auth:logOut.confirm')}
              </Button>
            </form>
          ) : (
            <>
              <Text as="h1" textStyle="headline4" mb="sm">
                {t('auth:loggedOut.title')}
              </Text>
              <Text textStyle="body-copy">{t('auth:loggedOut.body')}</Text>
            </>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  )
}

LogoutScreen.propTypes = {
  signedIn: PropTypes.bool.isRequired,
  logoutPath: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
}

export default LogoutScreen
